import { ActionIcon, Button, Menu } from "@mantine/core";
import {
	IconPointer,
	IconSquare,
	IconUser,
	IconPencilPlus,
	IconChevronDown,
} from "@tabler/icons-react";
import { useState } from "react";

export const BoxDrawModeControls = ({
	mode,
	handleSetMode,
}: {
	mode: "pan" | "draw" | "draw-user";
	handleSetMode: (mode: "pan" | "draw" | "draw-user") => void;
}) => {
	const [displayedDrawMode, setDisplayedDrawMode] = useState<
		"draw" | "draw-user"
	>("draw");
	const isDrawMode = mode === "draw" || mode === "draw-user";
	const drawIcon =
		displayedDrawMode === "draw-user" ? (
			<IconUser size={18} />
		) : (
			<IconPencilPlus size={18} />
		);

	return (
		<div className="fixed flex fixed bottom-20 z-[100] gap-2 p-3 justify-center items-center border-t border-gray-200 bg-gray-50 rounded-lg">
			<Button
				variant="outline"
				onClick={() => handleSetMode("pan")}
				leftSection={<IconPointer size={18} />}
				className={`transition-all duration-200 ${
					mode === "pan" ? "font-semibold" : "font-normal"
				}`}
				style={{
					border: `2px solid ${mode === "pan" ? "#3b82f6" : "#d1d5db"}`,
					backgroundColor: mode === "pan" ? "#eff6ff" : "white",
					color: mode === "pan" ? "#3b82f6" : "#6b7280",
				}}
				title="Default mode - Click and drag to move the image, click to select a box."
			>
				Default
			</Button>
			<div
				className="flex items-center"
				style={{
					border: `2px solid ${isDrawMode ? "#3b82f6" : "#d1d5db"}`,
					borderRadius: "4px",
					backgroundColor: isDrawMode ? "#eff6ff" : "white",
				}}
			>
				<Button
					variant="outline"
					rightSection={drawIcon}
					className={`transition-all duration-200 ${
						isDrawMode ? "font-semibold" : "font-normal"
					}`}
					style={{
						border: "none",
						borderRight: `1px solid ${isDrawMode ? "#3b82f6" : "#d1d5db"}`,
						borderRadius: "4px 0 0 4px",
						backgroundColor: "transparent",
						color: isDrawMode ? "#3b82f6" : "#6b7280",
					}}
					title="Draw mode - Click and drag to draw boxes"
					onClick={() => {
						handleSetMode(displayedDrawMode);
					}}
				>
					Draw
				</Button>
				<Menu shadow="md" width={200} position="top">
					<Menu.Target>
						<ActionIcon
							variant="transparent"
							size="lg"
							style={{
								border: "none",
								borderRadius: "0 4px 4px 0",
								color: isDrawMode ? "#3b82f6" : "#6b7280",
							}}
						>
							<IconChevronDown size={16} />
						</ActionIcon>
					</Menu.Target>
					<Menu.Dropdown>
						<Menu.Item
							leftSection={<IconPencilPlus size={18} />}
							onClick={() => {
								handleSetMode("draw");
								setDisplayedDrawMode("draw");
							}}
							style={{
								fontWeight: mode === "draw" ? 600 : 400,
							}}
						>
							Empty Area
						</Menu.Item>
						<Menu.Item
							leftSection={<IconUser size={18} />}
							onClick={() => {
								handleSetMode("draw-user");
								setDisplayedDrawMode("draw-user");
							}}
							style={{
								fontWeight: mode === "draw-user" ? 600 : 400,
							}}
						>
							Unblurred Person
						</Menu.Item>
					</Menu.Dropdown>
				</Menu>
			</div>
		</div>
	);
};
